import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import { ConfirmareDocumenteService } from "../confirmare-documente.service";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { formatDate } from "@angular/common";
import { NotificationService } from "src/app/services/notification.service";
import { finalize } from "rxjs";
import { DocumentConfirmation, DocumentConfirmationHistoric } from "../confirmare-documente.interface";

@Component({
    selector: 'app-view-confirmation',
    templateUrl: './view-confirmation.component.html',
    styleUrls: ['./view-confirmation.component.scss']
})
export class ViewConfirmationComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    dtOptions: any = {};
    helper = helper;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    isLoading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: DocumentConfirmation,
        private dialogRef: MatDialogRef<ViewConfirmationComponent>,
        private confirmareDocumenteService: ConfirmareDocumenteService,
        private notificationService: NotificationService,
        private http: HttpClient,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    renderDT() {
        this.dtOptions = {
            responsive: true,
            serverSide: false,
            searching: false,
            pageLength: 10,
            order: [[0, "desc"]],
            data: this.data.document_confirmare_istoric,
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: "ID",
                    orderable: true,
                    data: "id",
                },
                {
                    title: "Dată înregistrare",
                    orderable: false,
                    data: "created_at",
                    render: (data: any, type: any, row: any) => {
                        const formattedDate = formatDate(row.created_at, 'yyyy-MM-dd HH:mm:ss', 'en-US')
                        return `
                            <span>${formattedDate}</span>
                        `;
                    },
                },
                {
                    title: "Sursa",
                    orderable: false,
                    data: "source",
                    render: (data: any, type: any, row: any) => {
                        return `
                            <span>${row.source_denumire}</span>
                        `;
                    },
                },
                {
                    title: "IP",
                    orderable: false,
                    data: "ip",
                },
                {
                    title: "User agent (device)",
                    orderable: false,
                    data: "user_agent",
                },
                {
                    title: "Operator",
                    orderable: false,
                    data: "operator_name",
                },
            ],
        };
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    printDocumenteIstoric() {
        this.isLoading = true;

        this.confirmareDocumenteService.printDocumenteIstoric(this.data.id_confirmare)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (response: any) => {
                    let dataType = response.type;
                    let binaryData = [];
                    binaryData.push(response);
                    let downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
                    downloadLink.setAttribute('target', '_blank');
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
